import { render, staticRenderFns } from "./formEditDriver.vue?vue&type=template&id=810750c2"
import script from "./formEditDriver.vue?vue&type=script&lang=js"
export * from "./formEditDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('810750c2')) {
      api.createRecord('810750c2', component.options)
    } else {
      api.reload('810750c2', component.options)
    }
    module.hot.accept("./formEditDriver.vue?vue&type=template&id=810750c2", function () {
      api.rerender('810750c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/driver/components/form/formEditDriver.vue"
export default component.exports